(function () {
  if (window.dbplQuickAddInitialized) return;
  window.dbplQuickAddInitialized = true;

  var openModal = null;

  function getVariants(modal) {
    var script = modal.querySelector('[data-dbpl-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function selectedOptions(modal) {
    var groups = modal.querySelectorAll('[data-dbpl-option]');
    var options = [];
    groups.forEach(function (group) {
      var selected = group.querySelector('.dbpl-modal__value.is-selected');
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      options[index] = selected ? selected.getAttribute('data-value') : null;
    });
    return options;
  }

  function findVariant(modal) {
    var options = selectedOptions(modal);
    var variants = getVariants(modal);
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });
  }

  function updateVariant(modal) {
    var variant = findVariant(modal);
    var idInput = modal.querySelector('[data-dbpl-variant-id]');
    var priceEl = modal.querySelector('[data-dbpl-price]');
    var submitBtn = modal.querySelector('[data-dbpl-submit]');
    var submitText = modal.querySelector('[data-dbpl-submit-text]');
    var defaultLabel = submitBtn ? submitBtn.getAttribute('data-default-label') : null;

    if (submitBtn && !defaultLabel && submitText) {
      defaultLabel = submitText.textContent;
      submitBtn.setAttribute('data-default-label', defaultLabel);
    }

    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      }
      if (submitText) submitText.textContent = 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;

    if (variant.available) {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
      }
      if (submitText) submitText.textContent = defaultLabel || submitText.textContent;
    } else {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      }
      if (submitText) submitText.textContent = 'Sold out';
    }
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('dbpl-modal-lock', lock);
  }

  function gallerySlides(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll('[data-dbpl-gallery-slide]'));
  }

  function galleryThumbs(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll('[data-dbpl-gallery-thumb]'));
  }

  function currentGalleryIndex(modal) {
    var index = gallerySlides(modal).findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    return index === -1 ? 0 : index;
  }

  function setGalleryIndex(modal, index) {
    var slides = gallerySlides(modal);
    if (!slides.length) return;
    var thumbs = galleryThumbs(modal);
    var next = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === next); });
    thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === next); });
    var activeThumb = thumbs[next];
    if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function initPifw(modal) {
    if (modal.dataset.pifwInit) return;
    modal.dataset.pifwInit = '1';

    var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-pifw-tab]'));
    if (!tabs.length) return;
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-pifw-panel]'));
    var descContent = modal.querySelector('[data-pifw-desc-content]');
    var badgeEl = modal.querySelector('[data-pifw-badge]');
    var tabList = modal.querySelector('[data-pifw-tabs]');
    function switchPifwTab(idx) {
      tabs.forEach(function (t) {
        var isActive = t.getAttribute('data-pifw-tab') === String(idx);
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive);
        t.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-pifw-panel') !== String(idx);
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchPifwTab(this.getAttribute('data-pifw-tab'));
      });
    });

    if (tabList) {
      tabList.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(document.activeElement);
        if (idx < 0) return;
        var next = -1;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next >= 0) {
          e.preventDefault();
          tabs[next].focus();
          switchPifwTab(tabs[next].getAttribute('data-pifw-tab'));
        }
      });
    }

    if (descContent && badgeEl) {
      var items = descContent.querySelectorAll('li, h2, h3, h4, h5, h6');
      if (items.length > 0) {
        badgeEl.textContent = items.length;
        badgeEl.style.display = 'inline-block';
      }
    }
  }

  function open(modal) {
    if (openModal && openModal !== modal) close(openModal);
    modal.hidden = false;
    modal.querySelector('.dbpl-modal__panel').focus();
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    lockScroll(true);
    setGalleryIndex(modal, 0);
    initPifw(modal);
    openModal = modal;
  }

  function close(modal) {
    modal.classList.remove('is-open');
    lockScroll(false);
    setTimeout(function () {
      modal.hidden = true;
    }, 200);
    if (openModal === modal) openModal = null;
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-dbpl-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-dbpl-open'));
      if (modal) open(modal);
      return;
    }

    var closer = evt.target.closest('[data-dbpl-close]');
    if (closer) {
      var modalToClose = closer.closest('.dbpl-modal');
      if (modalToClose) close(modalToClose);
      return;
    }

    var value = evt.target.closest('.dbpl-modal__value');
    if (value) {
      var group = value.closest('[data-dbpl-option]');
      group.querySelectorAll('.dbpl-modal__value').forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      value.classList.add('is-selected');
      updateVariant(value.closest('.dbpl-modal'));
      return;
    }

    var qtyMinus = evt.target.closest('[data-dbpl-qty-minus]');
    if (qtyMinus) {
      var minusInput = qtyMinus.parentElement.querySelector('[data-dbpl-qty-input]');
      minusInput.value = Math.max(1, (parseInt(minusInput.value, 10) || 1) - 1);
      return;
    }

    var qtyPlus = evt.target.closest('[data-dbpl-qty-plus]');
    if (qtyPlus) {
      var plusInput = qtyPlus.parentElement.querySelector('[data-dbpl-qty-input]');
      plusInput.value = (parseInt(plusInput.value, 10) || 1) + 1;
      return;
    }

    var thumb = evt.target.closest('[data-dbpl-gallery-thumb]');
    if (thumb) {
      var thumbModal = thumb.closest('.dbpl-modal');
      setGalleryIndex(thumbModal, galleryThumbs(thumbModal).indexOf(thumb));
      return;
    }

    var galleryPrev = evt.target.closest('[data-dbpl-gallery-prev]');
    if (galleryPrev) {
      var prevModal = galleryPrev.closest('.dbpl-modal');
      setGalleryIndex(prevModal, currentGalleryIndex(prevModal) - 1);
      return;
    }

    var galleryNext = evt.target.closest('[data-dbpl-gallery-next]');
    if (galleryNext) {
      var nextModal = galleryNext.closest('.dbpl-modal');
      setGalleryIndex(nextModal, currentGalleryIndex(nextModal) + 1);
      return;
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && openModal) {
      close(openModal);
      return;
    }
    if ((evt.key === 'Enter' || evt.key === ' ') && evt.target.matches('[data-dbpl-open][role="button"]')) {
      evt.preventDefault();
      evt.target.click();
    }
    if (openModal && (evt.key === 'ArrowLeft' || evt.key === 'ArrowRight')) {
      if (!gallerySlides(openModal).length) return;
      evt.preventDefault();
      setGalleryIndex(openModal, currentGalleryIndex(openModal) + (evt.key === 'ArrowRight' ? 1 : -1));
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (openModal) close(openModal);
    });
  }
})();
